import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Fotter";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Memberships.css";
import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "./Config";

export default function Memberships() {
  const [Membership, setMemberShip] = useState([]);
  const [usermembership, setusermembership] = useState([]);
  const [Userinfo, setUserdatainfo] = useState([]);
  const [loading, setLoading] = useState(true);

  // console.log("user member", usermembership);

  const userId = Cookies.get("user_id");

  // console.log("active", userId);
  // Get Login User Data
  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_user_by_id.php?id=${userId}&t=${Date.now()}`)
      .then((res) => {
        if (res.data.success) {
          setUserdatainfo(res.data.data);
          //  console.log("userdata", res.data.data);
        } else {
          console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  }, [userId]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_membership.php?id=${userId}&t=${Date.now()}`)
      .then((res) => {
        if (res.data.success) {
          setusermembership(res.data.active);
          //  console.log("userdata  mem", res.data.active);
        } else {
          console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  }, [userId]);

  const fetchMemberships = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/get_membership_detail.php?t=${Date.now()}`
      );
      // console.log("JSON from PHP:", response.data); // must show JSON

      if (response.data.success) {
        setMemberShip(response.data.data);
      } else {
        setMemberShip([]);
      }
    } catch (error) {
      console.error("Failed to fetch memberships", error);
      setMemberShip([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMemberships();
  }, []);

  // ✅ Decode HTML entities
  function decodeHTMLEntities(text) {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  }
  const navigate = useNavigate();
  const location = useLocation();

  const handleStart = (plan) => {
    if (!userId) {
      // User not logged in

      navigate("/login", {
        state: { from: location },
      });
    } else {
      // User logged in
      navigate("/payment", { state: { plan } });
    }
  };

  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span> /</span>
                <p>Membership</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <div className="col-12" style={{ textAlign: "center" }}>
              <h1>
                <b>Membership</b>
              </h1>
              <p>Grow Your Business with FastTrade!</p>
            </div>

            <div className="plans mt-5 mb-5">
              <div className="row myplans">
                {loading
                  ? // Show 4 skeleton cards
                  [...Array(4)].map((_, index) => (
                    <div
                      className="col-sm-12 mb-sm-5 col-md-6 col-xl-3 col-lg-6"
                      key={index}
                    >
                      <div className="plan-page skeleton-card">
                        <div className="skeleton skeleton-title"></div>
                        <div className="skeleton skeleton-price"></div>
                        <div className="skeleton skeleton-benefits"></div>
                        <div className="skeleton skeleton-note"></div>
                        <div className="skeleton skeleton-button"></div>
                      </div>
                    </div>
                  ))
                  : Membership.map((plan, index) => (
                    <div
                      className="col-sm-12 mb-sm-5 col-md-6 col-xl-3 col-lg-6 mb-4"
                      key={plan.id || index}
                    >
                      <div
                        className={`plan-page ${index % 2 === 0 ? "" : "middle"
                          }`}
                      >
                        <h2>
                          <b>{plan.title}</b>
                        </h2>
                        <div className="price">
                          <p>{plan.amount}</p>
                          <p>
                            SAR{" "}
                            <span>
                              {plan.duration === "365"
                                ? " Per Year"
                                : "Per Month"}
                            </span>
                          </p>
                        </div>
                        <div
                          className="plan-detail"
                          dangerouslySetInnerHTML={{
                            __html: decodeHTMLEntities(plan.benifits),
                          }}
                        ></div>
                        <div className="detail-note plan-detail">
                          <p>{plan.note}</p>
                        </div>
                        <div
                          className={`buy ${plan.title === "Silver" ? "middle-buy" : ""
                            }`}
                        >
                          {Userinfo.membership_type === plan.title ? (
                            // CURRENT PLAN
                            <Link
                              to=""
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "black" : "#42b0ff",
                                color: "white",
                                textAlign: "center",
                                padding: "10px 15px",
                                borderRadius: "25px",
                                textDecoration: "none",
                                display: "inline-block",
                                width: "100%",
                                fontSize: "14px",
                                fontWeight: "500",
                                pointerEvents:
                                  plan.status == 0 ? "none" : "auto",
                                opacity: plan.status == 0 ? 0.6 : 1,
                              }}
                            >
                              Your Current Subscription
                            </Link>
                          ) : Number(plan.id) >= Number(usermembership.id) ? (
                            // UPGRADE — allowed
                            <div
                              onClick={() => handleStart(plan)}
                              style={{
                                backgroundColor:
                                  index % 2 === 0 ? "black" : "#42b0ff",
                                color: "white",
                                textAlign: "center",
                                padding: "10px 15px",
                                borderRadius: "25px",
                                width: "100%",
                                fontSize: "15px",
                                fontWeight: "500",
                                cursor: "pointer",
                                opacity: plan.status == 0 ? 0.6 : 1,
                                pointerEvents:
                                  plan.status == 0 ? "none" : "auto",
                              }}
                            >
                              Upgrade
                            </div>
                          ) : (
                            // DOWNGRADE — disabled
                            <div
                              onClick={
                                !userId ? () => handleStart(plan) : undefined
                              }
                              style={{
                                backgroundColor: userId ? "#888" : "#42b0ff",
                                color: "white",
                                textAlign: "center",
                                padding: "10px 15px",
                                borderRadius: "25px",
                                width: "100%",
                                fontSize: "15px",
                                fontWeight: "500",
                                opacity: userId ? 0.5 : 1,
                                cursor: userId ? "not-allowed" : "pointer",
                                pointerEvents: userId ? "none" : "auto",
                              }}
                            >
                              {userId ? "Not Available" : "Start Now"}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
